import { Resume as BaseResume } from '../../resume/resume';

export class Resume extends BaseResume {}
